import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {useNavigate, useParams} from "react-router-dom";
import {tokenExpiredLoginAgain, hostUrl, siteUrl, highTrafficInnerPages } from '../constants/global';
import allActions from '../actions/index';
import Audi from '../assets/images/audi.jpg';
import MobileTopAds from './sub-components/MobileTopAds';
import Screen from './sub-components/Screen';
import MobileBottomAds from './sub-components/MobileBottomAds';
import LeftAds from './sub-components/LeftAds';
import RightAds from './sub-components/RightAds';
import { client }  from './OwnWebsocket';
import { callPageRenderTracking } from './common/Helper';
import  Sessions  from './Sessions';

const Home = () => {

    const homeBucketState =  useSelector(state => state.HomeBucket);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    var bucketEmpty = false;
    /********check Knowledge Center is empty then bucket empty true********/
    // if(homeBucketState.bucket.datatrack===1){
    //     bucketEmpty = true;
    // }
    

    const [spinner, setSpinner] = useState(true);  
    const [responsemessage, setResponseMessage] = useState(""); 

    /******call this useEffect when again come to component with and without refresh**********/
    useEffect(() => {
        //console.log('Use Effect call Home center!', client);
                
        //dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));

        if (homeBucketState.datatrack===1) {
           
            //console.log('Use Effect inner Home center!');

            /******get data from localstorage*******/
            let authlogin = localStorage.getItem('authlogin');
            let storageData = authlogin ? JSON.parse(authlogin) : "";
            
            var token = 'Bearer '+storageData.token;
            var username = storageData.user_email;
            // var formdata = new FormData();
            // formdata.append("username", username);

            const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username
                }
             };

            fetch(siteUrl+'/community-rest-functions.php?action=home_page',requestOptions)
            .then((response) => response.json())
            .then(function(actualData){ 
                //console.log(actualData, "Home data");
                if(actualData.status==='success'){
                    dispatch( allActions.Home.setHomeData(actualData));
                    setSpinner(false);
                }else if(actualData.status==='validationerror'){
                    /*********Push data in data content popup*******/
                    dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                    //alert(tokenExpiredLoginAgain);
                    navigate('/login/?message='+tokenExpiredLoginAgain);
                    setSpinner(false);
                }else{
                    //dispatch( allActions.Home.setHomeData(actualData));
                    setSpinner(false);
                }
            }).catch(rejected => {
                setSpinner(false);
                setResponseMessage({status:"error",message:highTrafficInnerPages});
            });
            
        }
        
    },[]);

    /*********Open when need to show session recordings**********/
    var { id } = useParams();
    var screenData = "";
    /*******If session id is undefine then show Home page Video screen**********/
   if(typeof(id) === 'undefined'){

    /******call page render tracking********/
    callPageRenderTracking({page_title:'Home',page_link:window.location.href});

    //window.open("/sessions/");
    //window.location.reload("https://community.ciisummit.com/sessions/");
        screenData = <Screen />
   }else{
        screenData = <Sessions />
   }

    return (
        <>

        <div className="main-container">

        <div className="auditorim-box">
            <img src={Audi} alt="auditorim" className="audience-section" />
        </div>

        {responsemessage && <span className={responsemessage.status}>{responsemessage.message}</span>}

        {/* Mobile Top Ads start */}
        <MobileTopAds/>
        {/* Mobile Top Ads end */}


        {/* live frame start */}
            {screenData}
        {/* live frame end */}

        {/* Mobile Bottom Ads start */}
        <MobileBottomAds/>
        {/* Mobile Bottom Ads end */}


        {/* Left Desktop Ads start */}
        <LeftAds />
        {/* Left Desktop Ads end */}

        {/* Right Desktop Ads start */}
        <RightAds />
        {/* Right Desktop Ads end */}

        </div>
            
        </>
    )
}

export default Home;